import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as S from '../SrpMainBlock/SrpMainBlock.styles';
import SrpLeftBlock from '../SrpLeftBlock/SrpLeftBlock';
import SrpRightBlock from '../SrpRightBlock/SrpRightBlock';
import GoSafeZoneCard from '../GoSafeZone/GoSafeZone';
import GoSafePersuationTag from '../GoSafePersuation/GoSafePersuation';
import { IUserStoreState, userSelector } from 'user-reducer/src/user-reducer';
import { dataLoadingSelector, srpRawDataSelector, persuationDataSelector } from './../../../../containers/SRP/redux/selectors'
import { commonSelector, routeStateSelector } from '../../../../containers/Common/redux/selectors'
import { calculateDaysToTrip, convert_yyyymmdd_to_dd_mm_dddd, countRtcBuses } from '../../../../../shared/utils/ctaHelper'
import { pushOmniEvents } from '../../../../../shared/utils/PushEvents/Omniture/utils'
import { userLoyaltyInfo } from '../../../../containers/Home/redux/selectors';
import {getPokusKeys, sendRecentSearchData} from './utils'
const SrpMainBlock = (props) => {
  const { selectedFilters, setSelectedFilters, clearHorizontalFilterCards } = props;
  const srpDataLoading = useSelector(dataLoadingSelector);
  const [flag, setFlag] = useState(1)
  const { rawData } = useSelector(srpRawDataSelector);
  const { pokus_data = {} } = rawData
  const userDetails = useSelector(userSelector) as IUserStoreState;
  const commonData = useSelector(commonSelector);
  const { src, dest, doj, dojObj } = commonData;
  const isLoggedIn = !!userDetails?.isLoggedIn;
  const {userInfo,loyaltyInfo={}} = userDetails;
  const ps = useSelector(persuationDataSelector);
  const showCard = !srpDataLoading && rawData && rawData.buses && rawData.buses.length;
  const routeStates = useSelector(routeStateSelector)
  const userLoyalty = useSelector(userLoyaltyInfo)
  const userTier = userLoyalty?.userLoyaltyInfo?.user_tier == undefined ? '' : `${userLoyalty?.userLoyaltyInfo?.user_tier}`
  const [sendPageEvt, setSendPageEvt] = useState(0)
  const {city_info = {}} = rawData
  const {src_locus_id = '', dest_locus_id = ''  } = city_info
  useEffect(()=>{
    if(commonData?.srcLat && commonData?.srcLon && src_locus_id && dest_locus_id ){
      sendRecentSearchData(commonData, src_locus_id, dest_locus_id)
    }
  },[src_locus_id, dest_locus_id])
  useEffect(()=>{
    setTimeout(()=>{
      setSendPageEvt(1)
    }, 300)
  },[])

    if(flag && showCard && sendPageEvt === 1){
      const eventDetails = {
          page: {
            pageInfo: {
              section: "domestic bus funnel",
              pageName: "funnel:domestic bus:listing",
              pageType: "funnel",
              lob: "domestic bus",
              siteName: 'GI',
              platform: 'dWeb',
              flow: "direct-bus",
              loadedComponents: '',
              abVariant: getPokusKeys(pokus_data),
              deviceId: "",
              loyaltyStatus_v44:`Tier${loyaltyInfo?.status !=='INACTIVE' ? loyaltyInfo?.currentTier?.tierNumber || '' : '0'}_${loyaltyInfo?.status || ''}`,
            },
          },
          
          search : {
              searchId: `${src}-${dest}-${doj}`,
              noOfSearchResults:`${rawData?.buses?.length}`,
              noOfGovtBusResults: `${countRtcBuses(rawData?.operators)}`
           },
          booking: {
              routeCity: `${src}-${dest}`,
              routeState : (routeStates.srcState && routeStates.destState) ?  `${routeStates.srcState}-${routeStates.destState}` : '',
              daysToTrip: `${calculateDaysToTrip(dojObj)}`,
              departureDate: `${convert_yyyymmdd_to_dd_mm_dddd(doj)}`,
          },

        account: {
          accountInfo: {
            custID: userInfo?.userid ? `${userInfo?.userid}` : '',
            loginStatus: isLoggedIn ? "Logged-In" : "Guest",
            goCash: userDetails ? userDetails.gocashInfo ? `${userDetails?.gocashInfo?.data?.t_amt}` : "" : '',
            loyaltyStatus: userTier,
            "hydraSegment": "",
          },
        }
        };        
        pushOmniEvents({eventName:'pageView', details:eventDetails});
        setFlag(0);
      }

  return (
    <S.SrpcardLayoutDiv>
      {showCard ? <GoSafeZoneCard /> : null}
      {ps && showCard ? <GoSafePersuationTag ps={ps} /> : null}
      <S.SrpcardInnerLayoutDiv>
        <SrpLeftBlock
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          clearHorizontalFilterCards={clearHorizontalFilterCards}
        ></SrpLeftBlock>
        <SrpRightBlock selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} />
      </S.SrpcardInnerLayoutDiv>
    </S.SrpcardLayoutDiv>
  );
};

export default SrpMainBlock;
